const {ADD_MIXPANEL_EVENT} = require('../actionTypes')

export const addMixPanelEvent = (data) => {
    return {
        type: ADD_MIXPANEL_EVENT,
        payload: data,
    };
}